var map = {
	"./DynamicRegistration/en-US.json": 64247,
	"./DynamicRegistration/es.json": 38147,
	"./Tests/en-US.json": 44427,
	"./Tests/es.json": 99459,
	"./TokenView/en-US.json": 47333,
	"./TokenView/es.json": 26045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53849;